import styled from 'styled-components';
import { FontWeight, device } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  strong {
    font-weight: ${FontWeight.regular};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px;
  border-radius: 5px;
  background: ${({ theme }) => theme.neutral_200};
  gap: 25px;

  @media (max-width: ${device.mobile}px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  gap: 3px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: fit-content;
  align-self: flex-end;
`;

export const ButtonContent = styled.div`
  display: flex;
  gap: 6px;

  svg {
    width: 15px;
    height: 15px;
  }
`;
